<template>
  <div v-if="list">
    <div class="pa-3">
      <!-- Tip 1 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.amount_update_tip") }}</i
        >
      </div>
      <!-- Tip 2 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.refund_tip") }}</i
        >
      </div>
      <!-- Tip 3 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.discounted_sales") }}</i
        >
      </div>
    </div>
    <v-layout row wrap class="pa-3">
      <v-flex xs12 sm12 md12>
        <div v-if="Object.keys(selected_film).length">
          <v-btn
            class="mx-0"
            color="secondary"
            @click="resetFilmSpecificRevenue()"
          >
            <v-icon left small>$vuetify.icons.screener_back</v-icon>
            {{ $t("screener.monetization.revenue.back_to_film_list") }}
          </v-btn>
          <AboutRevenue
            :item="selected_film"
            :is_event_revenue="false"
          ></AboutRevenue>
        </div>
        <v-flex v-else xs12 sm3 md3>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('rms.field.search') + ' By Film'"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <template v-if="!Object.keys(selected_film).length">
      <v-data-table
        :headers="table_headers"
        :loading="loading"
        :items="list"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="value"
      >
        <template v-slot:headers="props">
          <tr>
            <template v-for="header in props.headers">
              <th
                :key="header.text"
                v-if="header.visibility"
                :class="[
                  'column sortable',
                  `text-xs-${header.align}`,
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                @click="changeSort(header.value)"
              >
                <span>{{ header.text }} </span>
              </th>
            </template>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            @click.stop="
              (props.expanded = !props.expanded),
                (selected_film = props.item),
                props.expanded ? getFilmSpecificRevenue() : ''
            "
            style="cursor: pointer"
          >
            <td class="body-2">{{ props.item.film }}</td>
            <td>
              <v-chip
                color="secondary"
                outline
                small
                v-for="screener in props.item.screeners"
                :key="screener.id"
                >{{ screener.title }}</v-chip
              >
            </td>

            <!-- For Company View-->
            <td v-if="isCompanyView">
              {{ props.item.right_holder ? props.item.right_holder : "---" }}
            </td>
            <td v-if="isCompanyView">
              {{
                props.item.right_holder_share
                  ? props.item.right_holder_share
                  : "---"
              }}
            </td>
            <!-- End Of Company View -->

            <td>{{ props.item.currency }}</td>

            <!-- For Company View-->
            <td v-if="isCompanyView">
              {{ props.item.total_amount | fixed }}
            </td>
            <td v-if="isCompanyView">
              {{ props.item.total_company_share | fixed }}
            </td>
            <!-- End Of Company View -->

            <td>{{ props.item.total_right_holder_share | fixed }}</td>
            <td>
              <span v-if="props.item.minimum_guarantee > 0" class="red--text"
                ><strong>-&nbsp;</strong></span
              >
              {{
                props.item.minimum_guarantee
                  ? props.item.minimum_guarantee
                  : "---"
              }}
            </td>
            <td>
              <span v-if="props.item.fees > 0" class="red--text"
                ><strong>-&nbsp;</strong></span
              >{{ props.item.fees ? props.item.fees : "---" }}
            </td>
            <td>{{ props.item.revenue_earned | fixed }}</td>
            <td>
              <v-icon color="success" v-if="props.item.is_revenue_processed"
                >$vuetify.icons.rms_check</v-icon
              >
              <v-icon color="error" v-else>$vuetify.icons.rms_close</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <template v-else>
      <v-data-table
        :headers="expansion_headers"
        :items="revenue"
        :loading="expansion_loading"
        :pagination.sync="expansion_pagination"
        :total-items="expansion_total"
        :rowsPerPageItems="expansion_rowsPerPageItems"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <router-link
                :to="{
                  name: 'consumer.index',
                  params: { consumer_id: props.item.consumer_id },
                }"
                >{{ props.item.consumer }}</router-link
              >
            </td>
            <td>
              <v-icon v-if="props.item.is_consumer_enrolled" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td>{{ props.item.pricing_plan }}</td>
            <td>
              {{ DEFINES.MONETIZATION.PURCHASE_TYPE[props.item.purchase_type] }}
            </td>
            <td>{{ props.item.screener }}</td>

            <td>{{ props.item.right_holder_share }}</td>
            <td>
              <v-icon color="success" v-if="props.item.is_revenue_processed"
                >$vuetify.icons.rms_check</v-icon
              >
              <v-icon color="error" v-else>$vuetify.icons.rms_close</v-icon>
            </td>
            <td>{{ fmtTime(props.item.created_at) }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { utcToTz } from "@/helper";
import i18n from "@/i18n";
import AboutRevenue from "./AboutRevenue";
export default {
  name: "FilmWiseRevenue",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.listRevenueByFilms();
    });
  },
  components: {
    AboutRevenue,
  },
  props: {
    isCompanyView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      table_headers: [
        {
          text: i18n.t("screener.table.header.film"),
          sortable: true,
          align: "left",
          value: "film",
          visibility: true,
        },
        {
          text: i18n.t("screener.table.header.screenings"),
          sortable: false,
          align: "left",
          value: "screeners",
          visibility: true,
        },
        {
          text: i18n.t("film.rightholder.title"),
          sortable: true,
          align: "left",
          value: "right_holder",
          visibility: this.isCompanyView,
        },
        {
          text: i18n.t("screener.table.header.right_holder_share_percent"),
          sortable: true,
          align: "left",
          value: "right_holder_share",
          visibility: this.isCompanyView,
        },
        {
          text: i18n.t("screener.table.header.currency"),
          sortable: false,
          align: "left",
          value: "currency",
          visibility: true,
        },
        {
          text: i18n.t("screener.table.header.total_amount"),
          sortable: true,
          align: "left",
          value: "total_amount",
          visibility: this.isCompanyView,
        },
        {
          text: i18n.t("screener.table.header.total_company_share"),
          align: "left",
          sortable: true,
          value: "total_company_share",
          visibility: this.isCompanyView,
        },
        {
          text: i18n.t("screener.table.header.total_right_holder_share"),
          align: "left",
          sortable: true,
          value: "total_right_holder_share",
          visibility: true,
        },
        {
          text: i18n.t("screener.monetization.minimum_guarantee"),
          align: "left",
          sortable: true,
          value: "minimum_guarantee",
          visibility: true,
        },
        {
          text: i18n.t("screener.monetization.fees"),
          align: "left",
          sortable: true,
          value: "fees",
          visibility: true,
        },
        {
          text: i18n.t("screener.table.header.right_holder_earned_revenue"),
          align: "left",
          sortable: true,
          value: "revenue_earned",
          visibility: true,
        },
        {
          text: "Paid",
          align: "left",
          value: "is_revenue_processed",
          sortable: true,
          visibility: true,
        },
      ],
      expansion_headers: [
        {
          text: i18n.t("screener.table.header.participant"),
          sortable: true,
          align: "left",
          value: "consumer",
        },
        {
          text: i18n.t("screener.table.header.participated"),
          sortable: false,
          align: "left",
          value: "is_consumer_enrolled",
        },
        {
          text: i18n.t("screener.table.header.pricing_plan"),
          sortable: false,
          align: "left",
          value: "pricing_plan",
        },
        {
          text: i18n.t("screener.table.header.plan_type"),
          sortable: false,
          align: "left",
          value: "purchase_type",
        },
        {
          text: "Screening",
          sortable: false,
          align: "left",
          value: "screener",
        },
        {
          text: i18n.t("screener.table.header.right_holder_share"),
          sortable: true,
          align: "left",
          value: "right_holder_share",
        },
        {
          text: "Paid",
          align: "left",
          value: "is_revenue_processed",
          sortable: true,
        },
        {
          text: i18n.t("screener.table.header.created_at"),
          sortable: true,
          align: "left",
          value: "created_at",
        },
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "total_revenue",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: "",
      loading: false,
      total: null,
      expansion_loading: false,
      revenue: [],
      selected_film: {},
      expansion_pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      expansion_total: null,
      expansion_rowsPerPageItems: [5, 10, 25, 50, 100],
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.revenue.list.filmWiseRevenue,
    }),
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
  },
  watch: {
    pagination: {
      handler: "listRevenueByFilms",
      deep: true,
    },
    expansion_pagination: {
      handler() {
        this.getFilmSpecificRevenue();
      },
      deep: true,
    },
  },
  methods: {
    applySearch() {
      if (this.search.length) this.listRevenueByFilms();
    },
    clearSearch() {
      this.search = "";
      this.listRevenueByFilms();
    },
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, "MMM Do YYYY, h:mm a");
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async listRevenueByFilms() {
      try {
        this.loading = true;
        // Pagination
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);
        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          search: this.search,
          filters: {},
        };

        var response = await this.$store.dispatch(
          "revenue/listByFilms",
          payload
        );
        this.total = response.film_wise_revenue.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),

    resetFilmSpecificRevenue() {
      this.selected_film = {};
    },
    // Returns all records for a screener
    async getFilmSpecificRevenue() {
      try {
        if (!Object.keys(this.selected_film).length) {
          return;
        }
        // Resetting old data when clicking on other summary record
        this.revenue = [];
        this.expansion_loading = true;

        // Pagination
        const {
          sortBy,
          descending,
          page,
          rowsPerPage,
        } = this.expansion_pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);

        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          film_id: this.selected_film.film_id,
        };

        var response = await this.$store.dispatch("revenue/list", payload);

        this.expansion_total = response.revenue.total;
        this.revenue = response.revenue.data;
        this.expansion_loading = false;
      } catch (error) {
        this.expansion_loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>
